(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pacco-brand-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pacco-brands')) {
  customElements.define('pacco-brands', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('[data-pause]').addEventListener('click', (event) => {
        const paused = this.toggleAttribute('data-paused');
        event.currentTarget.setAttribute('aria-pressed', String(paused));
      });
      this.addEventListener('shopify:block:select', () => this.setAttribute('data-paused', ''));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
